/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardApprovePurchasedLicense,
  DashboardCreatePurchasedLicense,
  DashboardDeclinePurchasedLicense,
  DashboardLicenseHolderRef,
  DashboardLicenseHolderSearchOutput,
  DashboardPurchasedLicenseDetail,
  DashboardPurchasedLicenseList,
  DashboardPurchasedLicenseStats,
  DashboardPurchasedLicensesControllerApprove400,
  DashboardPurchasedLicensesControllerApprove401,
  DashboardPurchasedLicensesControllerApprove404,
  DashboardPurchasedLicensesControllerApprove429,
  DashboardPurchasedLicensesControllerCreate400,
  DashboardPurchasedLicensesControllerCreate401,
  DashboardPurchasedLicensesControllerCreate404,
  DashboardPurchasedLicensesControllerCreate409,
  DashboardPurchasedLicensesControllerCreate429,
  DashboardPurchasedLicensesControllerDecline400,
  DashboardPurchasedLicensesControllerDecline401,
  DashboardPurchasedLicensesControllerDecline404,
  DashboardPurchasedLicensesControllerDecline429,
  DashboardPurchasedLicensesControllerDetail400,
  DashboardPurchasedLicensesControllerDetail401,
  DashboardPurchasedLicensesControllerDetail404,
  DashboardPurchasedLicensesControllerDetail429,
  DashboardPurchasedLicensesControllerExport400,
  DashboardPurchasedLicensesControllerExport401,
  DashboardPurchasedLicensesControllerExport413,
  DashboardPurchasedLicensesControllerExport429,
  DashboardPurchasedLicensesControllerExportParams,
  DashboardPurchasedLicensesControllerHolderRefs400,
  DashboardPurchasedLicensesControllerHolderRefs401,
  DashboardPurchasedLicensesControllerHolderRefs429,
  DashboardPurchasedLicensesControllerHolderRefsParams,
  DashboardPurchasedLicensesControllerList400,
  DashboardPurchasedLicensesControllerList401,
  DashboardPurchasedLicensesControllerList429,
  DashboardPurchasedLicensesControllerListParams,
  DashboardPurchasedLicensesControllerRemove400,
  DashboardPurchasedLicensesControllerRemove401,
  DashboardPurchasedLicensesControllerRemove404,
  DashboardPurchasedLicensesControllerRemove409,
  DashboardPurchasedLicensesControllerRemove429,
  DashboardPurchasedLicensesControllerReset400,
  DashboardPurchasedLicensesControllerReset401,
  DashboardPurchasedLicensesControllerReset404,
  DashboardPurchasedLicensesControllerReset429,
  DashboardPurchasedLicensesControllerSearchHolders400,
  DashboardPurchasedLicensesControllerSearchHolders401,
  DashboardPurchasedLicensesControllerSearchHolders429,
  DashboardPurchasedLicensesControllerSearchHoldersParams,
  DashboardPurchasedLicensesControllerStats400,
  DashboardPurchasedLicensesControllerStats401,
  DashboardPurchasedLicensesControllerStats429,
  DashboardPurchasedLicensesControllerStatsParams,
  DashboardPurchasedLicensesControllerUpdate400,
  DashboardPurchasedLicensesControllerUpdate401,
  DashboardPurchasedLicensesControllerUpdate404,
  DashboardPurchasedLicensesControllerUpdate429,
  DashboardResetPurchasedLicense,
  DashboardUpdatePurchasedLicense,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated purchased-license list scoped to the caller: the `LICENSE:READ` RBAC capability universe (incl. league-level grants), evaluated on the owning license (authoritative `license.platformId` attribution). `platformIds` and `federationIds` are pure filters applied together (AND of axes); the league filter is authoritative — when `leagueIds` is present the platform / federation filters are ignored and authorization narrows the requested league set instead. Requesting an out-of-scope id yields a narrowed (possibly empty) page, never a 403. Each row includes the license + holder summary, federation and accessible platforms, computed lifecycle status, approval status, sibling-aware totals (paidTotal/totalGross/totalNet/isBulkPurchase), the (user, license) pairs covered by a bulk purchase, decrypted bank-transfer details when relevant, and the proof upload status.
 * @summary List purchased licenses (dashboard)
 */
export const dashboardPurchasedLicensesControllerList = (
  params?: DashboardPurchasedLicensesControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseList>(
    { url: `/api/dashboard/v1/purchased-licenses`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPurchasedLicensesControllerListQueryKey = (
  params?: DashboardPurchasedLicensesControllerListParams
) => {
  return [`/api/dashboard/v1/purchased-licenses`, ...(params ? [params] : [])] as const;
};

export const getDashboardPurchasedLicensesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerList400
    | DashboardPurchasedLicensesControllerList401
    | DashboardPurchasedLicensesControllerList429
  >,
>(
  params?: DashboardPurchasedLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPurchasedLicensesControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>
  > = ({ signal }) => dashboardPurchasedLicensesControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPurchasedLicensesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>
>;
export type DashboardPurchasedLicensesControllerListQueryError = ErrorType<
  | DashboardPurchasedLicensesControllerList400
  | DashboardPurchasedLicensesControllerList401
  | DashboardPurchasedLicensesControllerList429
>;

export function useDashboardPurchasedLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerList400
    | DashboardPurchasedLicensesControllerList401
    | DashboardPurchasedLicensesControllerList429
  >,
>(
  params: undefined | DashboardPurchasedLicensesControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerList400
    | DashboardPurchasedLicensesControllerList401
    | DashboardPurchasedLicensesControllerList429
  >,
>(
  params?: DashboardPurchasedLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerList400
    | DashboardPurchasedLicensesControllerList401
    | DashboardPurchasedLicensesControllerList429
  >,
>(
  params?: DashboardPurchasedLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List purchased licenses (dashboard)
 */

export function useDashboardPurchasedLicensesControllerList<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerList400
    | DashboardPurchasedLicensesControllerList401
    | DashboardPurchasedLicensesControllerList429
  >,
>(
  params?: DashboardPurchasedLicensesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPurchasedLicensesControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record a purchased-license row. Federation and platforms are derived from the license and cannot be supplied or overridden. `approvalStatus` is set explicitly; it is never derived from the license. Exactly one of `holderUserId` (existing user) or `newHolder` (inline create) is required; the holder is auto-linked to the license's federation. Files (proof, additional-question attachments) must be uploaded through the storage flow first and referenced by `fileId`. Returns the same shape as `GET /:id`.
 * @summary Create purchased license (dashboard)
 */
export const dashboardPurchasedLicensesControllerCreate = (
  dashboardCreatePurchasedLicense: BodyType<DashboardCreatePurchasedLicense>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseDetail>(
    {
      url: `/api/dashboard/v1/purchased-licenses`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreatePurchasedLicense,
      signal,
    },
    options
  );
};

export const getDashboardPurchasedLicensesControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerCreate400
    | DashboardPurchasedLicensesControllerCreate401
    | DashboardPurchasedLicensesControllerCreate404
    | DashboardPurchasedLicensesControllerCreate409
    | DashboardPurchasedLicensesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePurchasedLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerCreate>>,
    { data: BodyType<DashboardCreatePurchasedLicense> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardPurchasedLicensesControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPurchasedLicensesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerCreate>>
>;
export type DashboardPurchasedLicensesControllerCreateMutationBody =
  BodyType<DashboardCreatePurchasedLicense>;
export type DashboardPurchasedLicensesControllerCreateMutationError = ErrorType<
  | DashboardPurchasedLicensesControllerCreate400
  | DashboardPurchasedLicensesControllerCreate401
  | DashboardPurchasedLicensesControllerCreate404
  | DashboardPurchasedLicensesControllerCreate409
  | DashboardPurchasedLicensesControllerCreate429
>;

/**
 * @summary Create purchased license (dashboard)
 */
export const useDashboardPurchasedLicensesControllerCreate = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerCreate400
    | DashboardPurchasedLicensesControllerCreate401
    | DashboardPurchasedLicensesControllerCreate404
    | DashboardPurchasedLicensesControllerCreate409
    | DashboardPurchasedLicensesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePurchasedLicense> },
  TContext
> => {
  const mutationOptions = getDashboardPurchasedLicensesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggregate counts (all/upcoming/passed/active/inactive/pending/approved/declined) under the same filter and scope as the list endpoint.
 * @summary Purchased-license aggregate counters (dashboard)
 */
export const dashboardPurchasedLicensesControllerStats = (
  params?: DashboardPurchasedLicensesControllerStatsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseStats>(
    { url: `/api/dashboard/v1/purchased-licenses/stats`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPurchasedLicensesControllerStatsQueryKey = (
  params?: DashboardPurchasedLicensesControllerStatsParams
) => {
  return [`/api/dashboard/v1/purchased-licenses/stats`, ...(params ? [params] : [])] as const;
};

export const getDashboardPurchasedLicensesControllerStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerStats400
    | DashboardPurchasedLicensesControllerStats401
    | DashboardPurchasedLicensesControllerStats429
  >,
>(
  params?: DashboardPurchasedLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPurchasedLicensesControllerStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>
  > = ({ signal }) => dashboardPurchasedLicensesControllerStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPurchasedLicensesControllerStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>
>;
export type DashboardPurchasedLicensesControllerStatsQueryError = ErrorType<
  | DashboardPurchasedLicensesControllerStats400
  | DashboardPurchasedLicensesControllerStats401
  | DashboardPurchasedLicensesControllerStats429
>;

export function useDashboardPurchasedLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerStats400
    | DashboardPurchasedLicensesControllerStats401
    | DashboardPurchasedLicensesControllerStats429
  >,
>(
  params: undefined | DashboardPurchasedLicensesControllerStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerStats400
    | DashboardPurchasedLicensesControllerStats401
    | DashboardPurchasedLicensesControllerStats429
  >,
>(
  params?: DashboardPurchasedLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerStats400
    | DashboardPurchasedLicensesControllerStats401
    | DashboardPurchasedLicensesControllerStats429
  >,
>(
  params?: DashboardPurchasedLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Purchased-license aggregate counters (dashboard)
 */

export function useDashboardPurchasedLicensesControllerStats<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerStats400
    | DashboardPurchasedLicensesControllerStats401
    | DashboardPurchasedLicensesControllerStats429
  >,
>(
  params?: DashboardPurchasedLicensesControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPurchasedLicensesControllerStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of the full filtered set with parity against `GET /purchased-licenses`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Section A is a fixed column block; Section B adds one column per distinct additional question encountered in the filtered rows, ordered by first occurrence in the sort.
 * @summary Export purchased licenses (dashboard)
 */
export const dashboardPurchasedLicensesControllerExport = (
  params: DashboardPurchasedLicensesControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/purchased-licenses/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardPurchasedLicensesControllerExportQueryKey = (
  params: DashboardPurchasedLicensesControllerExportParams
) => {
  return [`/api/dashboard/v1/purchased-licenses/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardPurchasedLicensesControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerExport400
    | DashboardPurchasedLicensesControllerExport401
    | DashboardPurchasedLicensesControllerExport413
    | DashboardPurchasedLicensesControllerExport429
  >,
>(
  params: DashboardPurchasedLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPurchasedLicensesControllerExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>
  > = ({ signal }) => dashboardPurchasedLicensesControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPurchasedLicensesControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>
>;
export type DashboardPurchasedLicensesControllerExportQueryError = ErrorType<
  | DashboardPurchasedLicensesControllerExport400
  | DashboardPurchasedLicensesControllerExport401
  | DashboardPurchasedLicensesControllerExport413
  | DashboardPurchasedLicensesControllerExport429
>;

export function useDashboardPurchasedLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerExport400
    | DashboardPurchasedLicensesControllerExport401
    | DashboardPurchasedLicensesControllerExport413
    | DashboardPurchasedLicensesControllerExport429
  >,
>(
  params: DashboardPurchasedLicensesControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerExport400
    | DashboardPurchasedLicensesControllerExport401
    | DashboardPurchasedLicensesControllerExport413
    | DashboardPurchasedLicensesControllerExport429
  >,
>(
  params: DashboardPurchasedLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerExport400
    | DashboardPurchasedLicensesControllerExport401
    | DashboardPurchasedLicensesControllerExport413
    | DashboardPurchasedLicensesControllerExport429
  >,
>(
  params: DashboardPurchasedLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export purchased licenses (dashboard)
 */

export function useDashboardPurchasedLicensesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerExport400
    | DashboardPurchasedLicensesControllerExport401
    | DashboardPurchasedLicensesControllerExport413
    | DashboardPurchasedLicensesControllerExport429
  >,
>(
  params: DashboardPurchasedLicensesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPurchasedLicensesControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated, autocomplete-friendly search over the DISTINCT holders (`pl.user`) of the purchased licenses the caller can see in the selected context. Scoped identically to `GET /purchased-licenses` (the `LICENSE:READ` capability universe on the owning license; `platformIds` / `federationIds` narrow within it, the league filter is authoritative). An inaccessible requested scope narrows to an empty page instead of a 403. Each holder carries `contactEmail` and `tournatedTag` alongside name / avatar / email.
 * @summary Search purchased-license holders (dashboard)
 */
export const dashboardPurchasedLicensesControllerSearchHolders = (
  params?: DashboardPurchasedLicensesControllerSearchHoldersParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseHolderSearchOutput>(
    { url: `/api/dashboard/v1/purchased-licenses/holders/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPurchasedLicensesControllerSearchHoldersQueryKey = (
  params?: DashboardPurchasedLicensesControllerSearchHoldersParams
) => {
  return [
    `/api/dashboard/v1/purchased-licenses/holders/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDashboardPurchasedLicensesControllerSearchHoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerSearchHolders400
    | DashboardPurchasedLicensesControllerSearchHolders401
    | DashboardPurchasedLicensesControllerSearchHolders429
  >,
>(
  params?: DashboardPurchasedLicensesControllerSearchHoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPurchasedLicensesControllerSearchHoldersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>
  > = ({ signal }) =>
    dashboardPurchasedLicensesControllerSearchHolders(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPurchasedLicensesControllerSearchHoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>
>;
export type DashboardPurchasedLicensesControllerSearchHoldersQueryError = ErrorType<
  | DashboardPurchasedLicensesControllerSearchHolders400
  | DashboardPurchasedLicensesControllerSearchHolders401
  | DashboardPurchasedLicensesControllerSearchHolders429
>;

export function useDashboardPurchasedLicensesControllerSearchHolders<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerSearchHolders400
    | DashboardPurchasedLicensesControllerSearchHolders401
    | DashboardPurchasedLicensesControllerSearchHolders429
  >,
>(
  params: undefined | DashboardPurchasedLicensesControllerSearchHoldersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerSearchHolders<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerSearchHolders400
    | DashboardPurchasedLicensesControllerSearchHolders401
    | DashboardPurchasedLicensesControllerSearchHolders429
  >,
>(
  params?: DashboardPurchasedLicensesControllerSearchHoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerSearchHolders<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerSearchHolders400
    | DashboardPurchasedLicensesControllerSearchHolders401
    | DashboardPurchasedLicensesControllerSearchHolders429
  >,
>(
  params?: DashboardPurchasedLicensesControllerSearchHoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search purchased-license holders (dashboard)
 */

export function useDashboardPurchasedLicensesControllerSearchHolders<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerSearchHolders400
    | DashboardPurchasedLicensesControllerSearchHolders401
    | DashboardPurchasedLicensesControllerSearchHolders429
  >,
>(
  params?: DashboardPurchasedLicensesControllerSearchHoldersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerSearchHolders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPurchasedLicensesControllerSearchHoldersQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rehydrates URL-backed holder filter chips, keeping only public ids (`usr_…`) with a purchased license the caller can see in the requested `platformIds` / `federationIds` / `leagueIds` scope. Same capability scoping as the search endpoint.
 * @summary Resolve purchased-license holder refs (dashboard)
 */
export const dashboardPurchasedLicensesControllerHolderRefs = (
  params: DashboardPurchasedLicensesControllerHolderRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLicenseHolderRef[]>(
    { url: `/api/dashboard/v1/purchased-licenses/holders/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPurchasedLicensesControllerHolderRefsQueryKey = (
  params: DashboardPurchasedLicensesControllerHolderRefsParams
) => {
  return [
    `/api/dashboard/v1/purchased-licenses/holders/refs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDashboardPurchasedLicensesControllerHolderRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerHolderRefs400
    | DashboardPurchasedLicensesControllerHolderRefs401
    | DashboardPurchasedLicensesControllerHolderRefs429
  >,
>(
  params: DashboardPurchasedLicensesControllerHolderRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPurchasedLicensesControllerHolderRefsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>
  > = ({ signal }) =>
    dashboardPurchasedLicensesControllerHolderRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPurchasedLicensesControllerHolderRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>
>;
export type DashboardPurchasedLicensesControllerHolderRefsQueryError = ErrorType<
  | DashboardPurchasedLicensesControllerHolderRefs400
  | DashboardPurchasedLicensesControllerHolderRefs401
  | DashboardPurchasedLicensesControllerHolderRefs429
>;

export function useDashboardPurchasedLicensesControllerHolderRefs<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerHolderRefs400
    | DashboardPurchasedLicensesControllerHolderRefs401
    | DashboardPurchasedLicensesControllerHolderRefs429
  >,
>(
  params: DashboardPurchasedLicensesControllerHolderRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerHolderRefs<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerHolderRefs400
    | DashboardPurchasedLicensesControllerHolderRefs401
    | DashboardPurchasedLicensesControllerHolderRefs429
  >,
>(
  params: DashboardPurchasedLicensesControllerHolderRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerHolderRefs<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerHolderRefs400
    | DashboardPurchasedLicensesControllerHolderRefs401
    | DashboardPurchasedLicensesControllerHolderRefs429
  >,
>(
  params: DashboardPurchasedLicensesControllerHolderRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve purchased-license holder refs (dashboard)
 */

export function useDashboardPurchasedLicensesControllerHolderRefs<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerHolderRefs400
    | DashboardPurchasedLicensesControllerHolderRefs401
    | DashboardPurchasedLicensesControllerHolderRefs429
  >,
>(
  params: DashboardPurchasedLicensesControllerHolderRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerHolderRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPurchasedLicensesControllerHolderRefsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Single purchased-license row with the same enriched shape as the list endpoint. 404 when the row does not exist or the caller has no federation access to it.
 * @summary Get purchased-license detail (dashboard)
 */
export const dashboardPurchasedLicensesControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseDetail>(
    { url: `/api/dashboard/v1/purchased-licenses/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardPurchasedLicensesControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/purchased-licenses/${id}`] as const;
};

export const getDashboardPurchasedLicensesControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDetail400
    | DashboardPurchasedLicensesControllerDetail401
    | DashboardPurchasedLicensesControllerDetail404
    | DashboardPurchasedLicensesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPurchasedLicensesControllerDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>
  > = ({ signal }) => dashboardPurchasedLicensesControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPurchasedLicensesControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>
>;
export type DashboardPurchasedLicensesControllerDetailQueryError = ErrorType<
  | DashboardPurchasedLicensesControllerDetail400
  | DashboardPurchasedLicensesControllerDetail401
  | DashboardPurchasedLicensesControllerDetail404
  | DashboardPurchasedLicensesControllerDetail429
>;

export function useDashboardPurchasedLicensesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDetail400
    | DashboardPurchasedLicensesControllerDetail401
    | DashboardPurchasedLicensesControllerDetail404
    | DashboardPurchasedLicensesControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDetail400
    | DashboardPurchasedLicensesControllerDetail401
    | DashboardPurchasedLicensesControllerDetail404
    | DashboardPurchasedLicensesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPurchasedLicensesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDetail400
    | DashboardPurchasedLicensesControllerDetail401
    | DashboardPurchasedLicensesControllerDetail404
    | DashboardPurchasedLicensesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get purchased-license detail (dashboard)
 */

export function useDashboardPurchasedLicensesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDetail400
    | DashboardPurchasedLicensesControllerDetail401
    | DashboardPurchasedLicensesControllerDetail404
    | DashboardPurchasedLicensesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPurchasedLicensesControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update — send only the fields a given form action owns; absent fields are left as-is, explicit `null` clears the column. License, federation, platforms, paymentIntentId are NOT updatable. `additionalQuestions` is replace-all: when the key is present, the submitted array IS the new state. When `holderUserId` changes, the new holder is auto-linked to the license's federation. `approvalStatus` is set explicitly — never derived from the license.
 * @summary Update purchased license (dashboard)
 */
export const dashboardPurchasedLicensesControllerUpdate = (
  id: string,
  dashboardUpdatePurchasedLicense: BodyType<DashboardUpdatePurchasedLicense>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardPurchasedLicenseDetail>(
    {
      url: `/api/dashboard/v1/purchased-licenses/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdatePurchasedLicense,
    },
    options
  );
};

export const getDashboardPurchasedLicensesControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerUpdate400
    | DashboardPurchasedLicensesControllerUpdate401
    | DashboardPurchasedLicensesControllerUpdate404
    | DashboardPurchasedLicensesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePurchasedLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdatePurchasedLicense> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPurchasedLicensesControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPurchasedLicensesControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerUpdate>>
>;
export type DashboardPurchasedLicensesControllerUpdateMutationBody =
  BodyType<DashboardUpdatePurchasedLicense>;
export type DashboardPurchasedLicensesControllerUpdateMutationError = ErrorType<
  | DashboardPurchasedLicensesControllerUpdate400
  | DashboardPurchasedLicensesControllerUpdate401
  | DashboardPurchasedLicensesControllerUpdate404
  | DashboardPurchasedLicensesControllerUpdate429
>;

/**
 * @summary Update purchased license (dashboard)
 */
export const useDashboardPurchasedLicensesControllerUpdate = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerUpdate400
    | DashboardPurchasedLicensesControllerUpdate401
    | DashboardPurchasedLicensesControllerUpdate404
    | DashboardPurchasedLicensesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePurchasedLicense> },
  TContext
> => {
  const mutationOptions = getDashboardPurchasedLicensesControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Soft-delete (sets `deletedAt`) the purchased-license row and its question answers. Audit history is preserved. Bulk-purchase rows (sharing a `paymentIntentId` with siblings) are refused with 409 `BULK_PURCHASE_DELETE` and the sibling ids in `details.siblingIds[]` so the FE can offer "delete all" vs "cancel".
 * @summary Delete a purchased license (dashboard)
 */
export const dashboardPurchasedLicensesControllerRemove = (
  id: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/purchased-licenses/${id}`, method: "DELETE" },
    options
  );
};

export const getDashboardPurchasedLicensesControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerRemove400
    | DashboardPurchasedLicensesControllerRemove401
    | DashboardPurchasedLicensesControllerRemove404
    | DashboardPurchasedLicensesControllerRemove409
    | DashboardPurchasedLicensesControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardPurchasedLicensesControllerRemove(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPurchasedLicensesControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerRemove>>
>;

export type DashboardPurchasedLicensesControllerRemoveMutationError = ErrorType<
  | DashboardPurchasedLicensesControllerRemove400
  | DashboardPurchasedLicensesControllerRemove401
  | DashboardPurchasedLicensesControllerRemove404
  | DashboardPurchasedLicensesControllerRemove409
  | DashboardPurchasedLicensesControllerRemove429
>;

/**
 * @summary Delete a purchased license (dashboard)
 */
export const useDashboardPurchasedLicensesControllerRemove = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerRemove400
    | DashboardPurchasedLicensesControllerRemove401
    | DashboardPurchasedLicensesControllerRemove404
    | DashboardPurchasedLicensesControllerRemove409
    | DashboardPurchasedLicensesControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDashboardPurchasedLicensesControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Side-effect-bearing transition to APPROVED. Writes an audit row and fires the holder + buyer notification template. `payment_status` is left untouched — it is owned by the payments path. Managers may approve from any current state (including already-terminal rows); there are no state-machine guards on this endpoint.
 * @summary Approve a purchased license (dashboard)
 */
export const dashboardPurchasedLicensesControllerApprove = (
  id: string,
  dashboardApprovePurchasedLicense: BodyType<DashboardApprovePurchasedLicense>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseDetail>(
    {
      url: `/api/dashboard/v1/purchased-licenses/${id}/approve`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardApprovePurchasedLicense,
      signal,
    },
    options
  );
};

export const getDashboardPurchasedLicensesControllerApproveMutationOptions = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerApprove400
    | DashboardPurchasedLicensesControllerApprove401
    | DashboardPurchasedLicensesControllerApprove404
    | DashboardPurchasedLicensesControllerApprove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerApprove>>,
    TError,
    { id: string; data: BodyType<DashboardApprovePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerApprove>>,
  TError,
  { id: string; data: BodyType<DashboardApprovePurchasedLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerApprove>>,
    { id: string; data: BodyType<DashboardApprovePurchasedLicense> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPurchasedLicensesControllerApprove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPurchasedLicensesControllerApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerApprove>>
>;
export type DashboardPurchasedLicensesControllerApproveMutationBody =
  BodyType<DashboardApprovePurchasedLicense>;
export type DashboardPurchasedLicensesControllerApproveMutationError = ErrorType<
  | DashboardPurchasedLicensesControllerApprove400
  | DashboardPurchasedLicensesControllerApprove401
  | DashboardPurchasedLicensesControllerApprove404
  | DashboardPurchasedLicensesControllerApprove429
>;

/**
 * @summary Approve a purchased license (dashboard)
 */
export const useDashboardPurchasedLicensesControllerApprove = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerApprove400
    | DashboardPurchasedLicensesControllerApprove401
    | DashboardPurchasedLicensesControllerApprove404
    | DashboardPurchasedLicensesControllerApprove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerApprove>>,
    TError,
    { id: string; data: BodyType<DashboardApprovePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerApprove>>,
  TError,
  { id: string; data: BodyType<DashboardApprovePurchasedLicense> },
  TContext
> => {
  const mutationOptions = getDashboardPurchasedLicensesControllerApproveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Side-effect-bearing transition to DECLINED. Optional `reason` is persisted on the row as `declineReason` (cleared on a subsequent approve/reset) and captured on the audit row. Fires holder + buyer notifications. Managers may decline from any current state; there are no state-machine guards on this endpoint. Refunds are out of scope for this surface — handled by the finance flow.
 * @summary Decline a purchased license (dashboard)
 */
export const dashboardPurchasedLicensesControllerDecline = (
  id: string,
  dashboardDeclinePurchasedLicense: BodyType<DashboardDeclinePurchasedLicense>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseDetail>(
    {
      url: `/api/dashboard/v1/purchased-licenses/${id}/decline`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardDeclinePurchasedLicense,
      signal,
    },
    options
  );
};

export const getDashboardPurchasedLicensesControllerDeclineMutationOptions = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDecline400
    | DashboardPurchasedLicensesControllerDecline401
    | DashboardPurchasedLicensesControllerDecline404
    | DashboardPurchasedLicensesControllerDecline429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDecline>>,
    TError,
    { id: string; data: BodyType<DashboardDeclinePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDecline>>,
  TError,
  { id: string; data: BodyType<DashboardDeclinePurchasedLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDecline>>,
    { id: string; data: BodyType<DashboardDeclinePurchasedLicense> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPurchasedLicensesControllerDecline(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPurchasedLicensesControllerDeclineMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDecline>>
>;
export type DashboardPurchasedLicensesControllerDeclineMutationBody =
  BodyType<DashboardDeclinePurchasedLicense>;
export type DashboardPurchasedLicensesControllerDeclineMutationError = ErrorType<
  | DashboardPurchasedLicensesControllerDecline400
  | DashboardPurchasedLicensesControllerDecline401
  | DashboardPurchasedLicensesControllerDecline404
  | DashboardPurchasedLicensesControllerDecline429
>;

/**
 * @summary Decline a purchased license (dashboard)
 */
export const useDashboardPurchasedLicensesControllerDecline = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerDecline400
    | DashboardPurchasedLicensesControllerDecline401
    | DashboardPurchasedLicensesControllerDecline404
    | DashboardPurchasedLicensesControllerDecline429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDecline>>,
    TError,
    { id: string; data: BodyType<DashboardDeclinePurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerDecline>>,
  TError,
  { id: string; data: BodyType<DashboardDeclinePurchasedLicense> },
  TContext
> => {
  const mutationOptions = getDashboardPurchasedLicensesControllerDeclineMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Revert the row to PENDING (or WAITING_FOR_PROOF for bank-transfer rows without proof). Audit-only; no holder notification fires. Managers may reset from any current state; there are no state-machine guards on this endpoint.
 * @summary Reset a purchased license back to pending (dashboard)
 */
export const dashboardPurchasedLicensesControllerReset = (
  id: string,
  dashboardResetPurchasedLicense: BodyType<DashboardResetPurchasedLicense>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPurchasedLicenseDetail>(
    {
      url: `/api/dashboard/v1/purchased-licenses/${id}/reset`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardResetPurchasedLicense,
      signal,
    },
    options
  );
};

export const getDashboardPurchasedLicensesControllerResetMutationOptions = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerReset400
    | DashboardPurchasedLicensesControllerReset401
    | DashboardPurchasedLicensesControllerReset404
    | DashboardPurchasedLicensesControllerReset429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerReset>>,
    TError,
    { id: string; data: BodyType<DashboardResetPurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerReset>>,
  TError,
  { id: string; data: BodyType<DashboardResetPurchasedLicense> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerReset>>,
    { id: string; data: BodyType<DashboardResetPurchasedLicense> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPurchasedLicensesControllerReset(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPurchasedLicensesControllerResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerReset>>
>;
export type DashboardPurchasedLicensesControllerResetMutationBody =
  BodyType<DashboardResetPurchasedLicense>;
export type DashboardPurchasedLicensesControllerResetMutationError = ErrorType<
  | DashboardPurchasedLicensesControllerReset400
  | DashboardPurchasedLicensesControllerReset401
  | DashboardPurchasedLicensesControllerReset404
  | DashboardPurchasedLicensesControllerReset429
>;

/**
 * @summary Reset a purchased license back to pending (dashboard)
 */
export const useDashboardPurchasedLicensesControllerReset = <
  TError = ErrorType<
    | DashboardPurchasedLicensesControllerReset400
    | DashboardPurchasedLicensesControllerReset401
    | DashboardPurchasedLicensesControllerReset404
    | DashboardPurchasedLicensesControllerReset429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerReset>>,
    TError,
    { id: string; data: BodyType<DashboardResetPurchasedLicense> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPurchasedLicensesControllerReset>>,
  TError,
  { id: string; data: BodyType<DashboardResetPurchasedLicense> },
  TContext
> => {
  const mutationOptions = getDashboardPurchasedLicensesControllerResetMutationOptions(options);

  return useMutation(mutationOptions);
};
